import { UploadTaskRequestTypeEnum } from "@nens/brostar/openapi-client";
import {
  CorrectionReasonOptions,
  GPDVolumeSeriesData,
  GpdMethodOptions,
  OptionalIndicationYesNoOptions,
  QualityRegimeOptions,
  correctionReasonOptions,
  gpdMethodOptions,
  gpdTemperatureOptions,
  gpdWaterInOutOptions,
  optionalIndicationYesNoOptions,
  qualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

const GPD_FIELD_SCHEMA_LIBRARY = {
  // Shared metadata fields
  projectNumber: addSchema<string>({ type: "string", title: "Projectnummer" }),
  broId: addSchema<string>({ type: "string", title: "BRO-ID Grondwatergebruiksdossier" }),
  qualityRegime: addSchema<QualityRegimeOptions>({
    type: "string",
    title: "Kwaliteitsregime",
    enum: qualityRegimeOptions.map((opt) => opt.value),
  }),
  deliveryAccountableParty: addSchema<string>({
    type: "string",
    title: "Bronhouder [KVK]",
  }),
  correctionReason: addSchema<CorrectionReasonOptions>({
    type: "string",
    title: "Correctie reden",
    enum: correctionReasonOptions.map((opt) => opt.value),
  }),

  // GPD Start Registration fields
  objectIdAccountableParty: addSchema<string>({ type: "string", title: "Interne naam" }),
  publiclyAvailable: addSchema<OptionalIndicationYesNoOptions>({
    type: "string",
    title: "Publiek beschikbaar",
    enum: optionalIndicationYesNoOptions.map((opt) => opt.value),
  }),

  // GPD Add Report fields
  reportId: addSchema<string>({ type: "string", title: "Rapport ID" }),
  method: addSchema<GpdMethodOptions>({
    type: "string",
    title: "Methode",
    enum: gpdMethodOptions.map((opt) => opt.value),
  }),
  groundwaterUsageFacilityBroId: addSchema<string>({
    type: "string",
    title: "BRO-ID Grondwatergebruiksysteem",
  }),
  volumeSeries: addSchema<GPDVolumeSeriesData[]>({
    type: "array",
    title: "Volume tijdreeks",
    items: {
      type: "object",
      required: ["waterInOut", "volume", "beginDate", "endDate"],
      properties: {
        waterInOut: {
          type: "string",
          title: "Onttrokken/Ingebracht",
          enum: gpdWaterInOutOptions.map((opt) => opt.value),
        },
        volume: {
          type: "number",
          title: "Volume (m3)",
          minimum: 0,
        },
        temperature: {
          type: "string",
          title: "Temperatuur",
          enum: gpdTemperatureOptions.map((opt) => opt.value),
        },
        beginDate: {
          type: "string",
          title: "Begin datum",
          format: "date",
        },
        endDate: {
          type: "string",
          title: "Eind datum",
          format: "date",
        },
      },
    },
  }),
  volumeFile: addSchema<Blob>({
    type: "string",
    format: "data-url",
    title: "Volumebestand (Excel)",
  }),
  reportFile: addSchema<Blob>({
    type: "string",
    format: "data-url",
    title: "Rapportbestand (Excel)",
  }),

  requestType: addSchema<UploadTaskRequestTypeEnum>({
    type: "string",
    title: "Request Type",
    enum: Object.values(UploadTaskRequestTypeEnum),
  }),
};

type FieldSchemaLibraryType = typeof GPD_FIELD_SCHEMA_LIBRARY;

export function pickGpdLibraryFields<K extends keyof FieldSchemaLibraryType>(
  fieldNames: readonly K[]
): Pick<FieldSchemaLibraryType, K> {
  const result = {} as Pick<FieldSchemaLibraryType, K>;
  for (const name of fieldNames) {
    result[name] = GPD_FIELD_SCHEMA_LIBRARY[name];
  }
  return result;
}
